import { AccessTime, DriveFileRenameOutline } from '@mui/icons-material'
import { Tooltip } from '@mui/material'

/**
 * Shows how an entry's duration was captured.
 *
 * `startTime` is stamped by the startTimer mutation and is never written by
 * createManualEntry, so its presence is what separates a clock-tracked entry
 * from a hand-logged one — no extra column needed to tell them apart.
 */
export const EntrySourceIcon = ({ startTime }: { startTime?: string | null }) => {
  const trackedByClock = !!startTime
  const label = trackedByClock ? 'Tracked with the timer' : 'Logged manually'
  const sx = { fontSize: '1rem', color: 'text.secondary', display: 'block' }

  return (
    <Tooltip title={label} arrow placement="top">
      {trackedByClock ? (
        <AccessTime titleAccess={label} sx={sx} />
      ) : (
        <DriveFileRenameOutline titleAccess={label} sx={sx} />
      )}
    </Tooltip>
  )
}
